import { render, staticRenderFns } from "./UseTermsDataControllerModal.vue?vue&type=template&id=cb16eafe&scoped=true"
import script from "./UseTermsDataControllerModal.vue?vue&type=script&lang=js"
export * from "./UseTermsDataControllerModal.vue?vue&type=script&lang=js"
import style0 from "./UseTermsDataControllerModal.vue?vue&type=style&index=0&id=cb16eafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb16eafe",
  null
  
)

export default component.exports